module.exports = "/static/js/ec15b28ba6a2fc0927865f93f1d7b365.png";